/**
 * Asynchronously loads the component for MyautoiqCampaignsViewPage
 */

import { lazyLoad } from 'utils/loadable';

export const MyautoiqCampaignsViewPage = lazyLoad(
  () => import('./index'),
  module => module.MyautoiqCampaignsViewPage,
);
